import gql from 'graphql-tag';
import { JOB_FRAGMENT } from '../schemas';

export const PAGINATED_JOBS = gql`
  ${JOB_FRAGMENT}

  query jobs(
    $status: JobStatus
    $searchText: String
    $after: String
    $before: String
    $first: Int
    $last: Int
    $scheduledOnGte: ISO8601Date
    $scheduledOnLte: ISO8601Date
    $includeAllGoAnytime: Boolean
  ) {
    jobs(
      status: $status
      searchText: $searchText
      after: $after
      before: $before
      first: $first
      last: $last
      scheduledOnGte: $scheduledOnGte
      scheduledOnLte: $scheduledOnLte
      includeAllGoAnytime: $includeAllGoAnytime
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        ...JobFragment
      }
    }
  }
`;
